import React, {Component} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
    Label,
    Collapse
} from 'reactstrap'
import PropTypes from 'prop-types'
import {Query, Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    AvForm,
    AvField,
} from 'availity-reactstrap-validation'
import {toast} from "react-toastify";

import LoadingButton from "../LoadingButton";

import query from '../../../queries/server/leave_unbillable_types';
import mutation from '../../../queries/server/mutations/add_user_leave'

export default class UserAnnualLeaveInput extends Component {

    state = {
        unbillable_type_id: '',
        note: '',
        leave_days: ''
    }

    render() {

      const {isOpen, toggle, user_id, onSave} = this.props;
      const {unbillable_type_id, note, leave_days} = this.state;

      return (

          <Mutation mutation={mutation}>
              {(addUserLeave, mutationState) => (

                  <Modal isOpen={isOpen} toggle={toggle} size="md">
                      <AvForm
                          onInvalidSubmit={() => {
                              console.log('invalid')
                          }}
                          onValidSubmit={() => {

                              addUserLeave({
                                  variables: {
                                      data: {
                                        ...this.state,
                                        user_id
                                      }
                                  }
                              })
                                  .then(({data}) => {
                                      if (onSave) onSave(data.addUserLeave)
                                      toast.success('Leave Added', {autoClose: 2000})
                                  })
                                  .catch(e => toast.error(e.message, {autoClose: false}))
                          }}>
                          <ModalHeader>Add Leave</ModalHeader>
                            <ModalBody>
                              <Query query={query}>
                                  {({data, loading}) => (
                                    <AvField
                                        required
                                        errorMessage="Required"
                                        label="Leave Type *"
                                        type="select"
                                        name="unbillable_type_id"
                                        id="unbillable_type_id"
                                        size="sm"
                                        value={unbillable_type_id}
                                        onChange={evt => {
                                            this.setState({unbillable_type_id: evt.target.value})
                                        }}
                                    >
                                      <option>{loading ? 'Loading...' : '---Choose Leave Type---'}</option>
                                      {
                                        (!loading && data) && data.leave_unbillable_types.map(({unbillable_type_id, description}) => <option key={unbillable_type_id} value={unbillable_type_id}>{description}</option>)
                                      }
                                    </AvField>
                                  )}
                              </Query>

                              <AvField
                                  required
                                  errorMessage="Required"
                                  label="Leave Amount (Days) *"
                                  type="number"
                                  name="leave_days"
                                  id="leave_days"
                                  size="sm"
                                  value={leave_days}
                                  onChange={evt => {
                                      this.setState({leave_days: evt.target.value})
                                  }}
                              />

                              <AvField
                                  label="Note"
                                  type="textarea"
                                  name="note"
                                  id="note"
                                  size="sm"
                                  value={note}
                                  onChange={evt => {
                                      this.setState({note: evt.target.value})
                                  }}
                              />
                              
                            </ModalBody>
                              
                          <ModalFooter>

                              <Button
                                  size="sm"
                                  color="success"
                                  disabled={mutationState.loading}
                              >
                                  <FontAwesomeIcon
                                      color="#fff"
                                      icon={mutationState.loading ? 'spinner' : 'save'}
                                      spin={mutationState.loading}
                                  />
                                  {' '}
                                  {mutationState.loading ? 'Saving...' : 'Save'}
                              </Button>
                          </ModalFooter>
                      </AvForm>
                  </Modal>

              )}

          </Mutation>
      )

    }

}

UserAnnualLeaveInput.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    user_id: PropTypes.number.isRequired
}